export default __webpack_public_path__ + "static/media/grp2_w320.5456383d.jpeg";